import { ServicesForm } from "../common/constants/forms/ServicesForm";
import { formState } from "../modules/form/FormState";
const sendForm = new ServicesForm(formState);
window.setService = setService;
window.setServiceDataliving = setServiceDataliving;
window.sendServices = sendForm.submitForm;
const isDataliving = window.location.pathname == '/dataliving';
formState.manageState('formName', '#form_service');
if (isDataliving) {
    formState.manageState('valueFields', 8);
}
else {
    formState.manageState('valueFields', 9);
}
function setService(event, typeForm) {
    var _a, _b, _c;
    const target = event.target;
    if (target && target.getAttribute('data-bs-toggle') === 'modal') {
        formState.manageState('formName', `#form_${typeForm}_modal`);
    }
    const formName = formState.manageState('formName');
    const selectedService = event.target.getAttribute("data-value");
    const serviceInput = document.querySelector(`${formName} [name="service"]`);
    if (serviceInput && selectedService) {
        serviceInput.value = selectedService;
        serviceInput.dispatchEvent(new Event('change'));
    }
    (_a = document.querySelector(`${formName} .js-confirmation-mess`)) === null || _a === void 0 ? void 0 : _a.classList.remove('d-flex');
    (_b = document.querySelector(`${formName} #load-send-form`)) === null || _b === void 0 ? void 0 : _b.classList.remove('d-flex');
    (_c = document.querySelector(`${formName} .container-form`)) === null || _c === void 0 ? void 0 : _c.classList.remove('d-none');
}
function setServiceDataliving(event) {
    setService(event, 'dataliving');
    const stickyForm = document.querySelector('.dataliving__sticky-form__form');
    stickyForm === null || stickyForm === void 0 ? void 0 : stickyForm.classList.add('dataliving__sticky-form__form--highlighted');
    const titles = document.querySelectorAll('.title');
    const subtitles = document.querySelectorAll('.subtitle');
    titles.forEach((title) => title.innerText = "Diligencie el formulario");
    subtitles.forEach((subtitle) => subtitle.innerText = "Dentro de poco le brindaremos más información");
    const nameInput = document.getElementById('nameInput');
    nameInput === null || nameInput === void 0 ? void 0 : nameInput.focus();
}
